var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.67472 0.5H15.8214C16.0299 0.5 16.2298 0.587797 16.3772 0.744078C16.5246 0.900358 16.6074 1.11232 16.6074 1.33333V14.6667C16.6074 14.8877 16.5246 15.0996 16.3772 15.2559C16.2298 15.4122 16.0299 15.5 15.8214 15.5H1.67472C1.46628 15.5 1.26638 15.4122 1.11899 15.2559C0.971597 15.0996 0.888794 14.8877 0.888794 14.6667V1.33333C0.888794 1.11232 0.971597 0.900358 1.11899 0.744078C1.26638 0.587797 1.46628 0.5 1.67472 0.5ZM8.79523 7.73583L3.75586 3.19833L2.73808 4.46833L8.80545 9.93083L14.7636 4.46417L13.7356 3.20333L8.79602 7.73583H8.79523Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.1a6bfe5ed287ca4d6cfb25f2f60e4cf1.svg";
export { ForwardRef as ReactComponent };